import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';

const About: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50 text-gray-900 antialiased">
      <Header />

      <main className="mx-auto max-w-4xl px-6 py-8">
        <div className="mb-6">
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center gap-2 text-purple-600 hover:text-purple-700 font-medium"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to Dashboard
          </button>
        </div>

        <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
          <div className="bg-gradient-to-r from-purple-600 to-pink-600 px-8 py-12 text-white">
            <div className="text-center">
              <h1 className="text-4xl font-bold mb-4">About QuizCrunch</h1>
              <p className="text-purple-100 text-xl">Create engaging quizzes with ease</p>
            </div>
          </div>

          <div className="p-8">
            <div className="space-y-6">
              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                  <span className="text-purple-600">🏢</span>
                  Responsible Company
                </h2>
                <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-6 border-2 border-purple-200">
                  <div className="flex items-center gap-4 mb-4">
                    <div className="w-16 h-16 bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl flex items-center justify-center text-white text-2xl font-bold">
                      H
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-800">Hugverk AI</h3>
                      <p className="text-gray-600">Technology Solutions</p>
                    </div>
                  </div>
                  <div className="space-y-3 text-gray-700">
                    <p className="font-medium">Organization Number: NO918988769MVA</p>
                    <div>
                      <p className="font-medium">Address:</p>
                      <p>Rudsberghaugen 34</p>
                      <p>2005 Rælingen, Norway</p>
                    </div>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                  <span className="text-purple-600">📞</span>
                  Customer Service
                </h2>
                <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-xl p-6 border-2 border-blue-200">
                  <div className="space-y-4 text-gray-700">
                    <div className="flex items-center gap-3">
                      <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                      <a href="tel:+4799356459" className="text-lg hover:text-purple-600 transition-colors">
                        (+47) 99356459
                      </a>
                    </div>
                    <div className="flex items-center gap-3">
                      <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                      <a href="mailto:post@glennbech.no" className="text-lg hover:text-purple-600 transition-colors">
                        post@glennbech.no
                      </a>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default About;